// Generated by purs version 0.15.0
import * as Record from "../Record/index.js";
var mkNamedParamsFn = function () {
    return function () {
        return function (defaults) {
            return function (impl) {
                return function (params) {
                    return impl(Record.merge()()(params)(defaults));
                };
            };
        };
    };
};
export {
    mkNamedParamsFn
};
//# sourceMappingURL=index.js.map
